import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  container: {
    padding: 0,
    margin: 0,
    height: 428,
    maxHeight: 428,
    overflowY: 'hidden',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 246px)',
    },
  },
  gridContainer: {
    backgroundColor: theme.palette.paper.secondary,
  },
  noCoursesContainer: {
    marginTop: 10,
    backgroundColor: theme.palette.paper.primary,
    width: '100%',
  },
  courseGridContainer: {
    height: 355,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  courseGrid: {
    width: 317,
    height: 'auto',
    [theme.breakpoints.down(400)]: {
      width: 282,
    },
  },
  singleCourse: {
    width: '100%',
    padding: theme.spacing(1),
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.paper.primary,
    borderRadius: theme.spacing(1),
    boxShadow: '0 0 3px rgba(0,0,0,0.3)',
  },
  sectionGrid: {
    marginRight: theme.spacing(4),
  },
  singleLine: {
    marginBottom: theme.spacing(0.5),
  },
  link: {
    color: theme.palette.components.linkText,
    padding: 0,
    marginTop: -1,
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
    },
  },
  selectContainer: {
    width: 316,
    padding: 8,
    marginTop: 4,
    marginBottom: 3,
    marginLeft: 4,
    backgroundColor: theme.palette.paper.primary,
    borderRadius: theme.spacing(1),
    boxShadow: '0 0 3px rgba(0,0,0,0.3)',
    [theme.breakpoints.down(400)]: {
      width: 285,
    },
  },
  selector: {
    width: '100%',
    height: 35,
  },
}))

export default styles
